/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CasesToForwardAssignRequest } from '../../models/cases-to-forward-assign-request';
import { Tour } from '../../models/tour';

export interface AssignRollbackRsaCase$Params {
      body: CasesToForwardAssignRequest
}

export function assignRollbackRsaCase(http: HttpClient, rootUrl: string, params: AssignRollbackRsaCase$Params, context?: HttpContext): Observable<StrictHttpResponse<Tour>> {
  const rb = new RequestBuilder(rootUrl, assignRollbackRsaCase.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Tour>;
    })
  );
}

assignRollbackRsaCase.PATH = '/api/v1/rsa/tours/forward_rollback_case';
